export const restSinNegocio = (obj) => {
  return obj.id.replace(obj.negocio + '-', '');
}